import React from 'react';
import { KPICard } from '../components/KPICard';
type Page = 'dashboard' | 'repayments' | 'applications' | 'scheduler' | 'activitylog';
interface DashboardPageProps {
  onNavigate: (page: Page) => void;
}
export function DashboardPage({
  onNavigate
}: DashboardPageProps) {
  const metrics = [{
    label: 'Active Loan Accounts',
    value: '1,245',
    page: 'applications' as Page
  }, {
    label: 'Settled Loan Accounts',
    value: '820',
    page: 'applications' as Page
  }, {
    label: 'Repayments Due Today',
    value: '56',
    page: 'repayments' as Page
  }, {
    label: 'Overdue Repayments',
    value: '18',
    page: 'repayments' as Page
  }, {
    label: 'GL Postings',
    value: '3,412',
    page: 'activitylog' as Page
  }];
  return <div className="space-y-8" data-id="element-653">
      <div data-id="element-654">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-655">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-656">
          Overview of loan portfolio and daily tasks.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5" data-id="element-657">
        {metrics.map(metric => <KPICard key={metric.label} label={metric.label} value={metric.value} onClick={() => onNavigate(metric.page)} data-id="element-658" />)}
      </div>

      {/* Recent Activity Section could go here if needed, keeping it minimal as requested */}
      <div className="bg-white shadow-sm rounded-lg border border-gray-200 p-6" data-id="element-659">
        <h3 className="text-lg font-medium leading-6 text-gray-900 mb-4" data-id="element-660">
          System Status
        </h3>
        <div className="text-sm text-gray-500" data-id="element-661">
          All systems operational. Last scheduler run completed successfully at
          02:00 AM.
        </div>
      </div>
    </div>;
}